/**
 * Theme-variant detection for embedded portals.
 *
 * This app is embedded into host pages the same way the company/subdomain
 * context is: the host page places a marker element in the DOM before this
 * bundle mounts (see the PSB_CID / PSB_SUB pattern in src/index.js), and we
 * read it at boot.
 *
 * To opt an embed into the "standard" (close-to-original, white background)
 * palette instead of the default premium theme, the host page includes:
 *
 *   <div id="PSB_THEME" theme-id="standard"></div>
 *
 * anywhere before the portal's script tag. Omitting the marker (or any
 * theme-id other than "standard") keeps the default premium theme.
 *
 * Both the MUI theme (colors.js) and the plain CSS (psb-helpers.scss, via
 * the psb-theme-standard class toggled in index.js) read this same value,
 * so keep it as the single source of truth rather than re-checking the
 * marker in more than one place.
 */

const VALID_VARIANTS = ["premium", "standard"];

export function getThemeVariant() {
  if (typeof document === "undefined") {
    return "premium";
  }
  const marker = document.getElementById("PSB_THEME");
  const requested = marker?.getAttribute("theme-id");
  return VALID_VARIANTS.includes(requested) ? requested : "premium";
}
